import { TimelineItem, TimelineItemSettings, TimelineItemType } from 'app/views/home/timeline/TimelineItem';
import { TimelineItemConfig } from 'app/model/TimelineItemConfig';
import { DepartmentType } from 'app/data/Enums';

export class RelativeChildren extends TimelineItem {
	//Child partciles
	private _childParticles: Array<TimelineItem> = [];

	public create(jsonConfig: TimelineItemConfig, settings: TimelineItemSettings): void {
		//Set the department based on postion
		this.id = jsonConfig.id;
		this.maskRegion = jsonConfig.maskRegion;
		this.type = TimelineItemType.RELATIVE_CHILDREN;
		this._repellActive = true;
		this.department = this.relativeX < 0.5 ? DepartmentType.SCREENS : DepartmentType.SPACES;
		this._createChildItems(jsonConfig, settings);
	}

	public resize(
		containerWidth: number,
		containerHeight: number,
		displayScale: number,
		innerwidth: number,
		positionScale: number
	) {
		this._childParticles.forEach((particle) => {
			particle.resize(containerWidth, containerHeight, displayScale, innerwidth, positionScale);
		});
	}

	public tick(
		xProgressRatio: number,
		containerX: number,
		mouseYRatio: number,
		mouseXRatio: number,
		mouseIsDown: boolean = false,
		velocityRatio: number = 0,
		instant: boolean = false,
		mousecords: any = null,
		mothcords: any = null
	): void {
		this._childParticles.forEach((particle) => {
			particle.tick(
				xProgressRatio,
				containerX,
				mouseYRatio,
				mouseXRatio,
				mouseIsDown,
				velocityRatio,
				instant,
				mousecords,
				mothcords
			);
		});
	}

	public animateToWork(moveY: number, delay: number = 0): void {
		this._childParticles.forEach((particle) => {
			particle.animateToWork(moveY, delay);
		});
	}

	public animateFromWork(delay: number = 1.0): void {
		this._childParticles.forEach((particle) => {
			particle.animateFromWork(delay);
		});
	}

	public resetIntervalsAndAnimations(): void {
		this._childParticles.forEach((particle) => {
			particle.resetIntervalsAndAnimations();
		});
	}

	public reset(): void {
		this._childParticles.forEach((particle) => {
			particle.reset();
		});
	}

	public getItems(): Array<TimelineItem> {
		return this._childParticles;
	}

	public resetFromWork(offY: number): void {
		this._childParticles.forEach((particle) => {
			particle.resetFromWork(offY);
		});
	}

	//Private
	//----------------------------------------------------------------------------------------
	private _createChildItems(parentConfig: TimelineItemConfig, settings: TimelineItemSettings): void {
		let baseX: number = parentConfig.relativeX;
		let rangeX: number = parentConfig.relativeChildrenWidth;

		let baseY: number = parentConfig.relativeY;
		let rangeY: number = parentConfig.relativeChildrenHeight;

		parentConfig.children.forEach((child: TimelineItemConfig, index: number) => {
			let config: TimelineItemConfig = {
				id: `${parentConfig.id}-particle-${index}`,
				relativeX: baseX + child.relativeX * rangeX,
				relativeY: baseY + child.relativeY * rangeY,
				easePower: parentConfig.easePower,
				parallaxOffsetPower: parentConfig.parallaxOffsetPower,
				parallaxPowerMouse: 0,
				autoScale: parentConfig.autoScale,
				autoRotate: parentConfig.autoRotate,
				autoAlpha: parentConfig.autoAlpha,
				randomRotation: parentConfig.randomRotation,
				startScale: parentConfig.startScale,
				minScale: parentConfig.minScale,
				maxScale: parentConfig.maxScale,
				autoRange: parentConfig.autoRange,
				alpha: parentConfig.alpha,
				tint: parentConfig.tint,
				repell: false,
				mouseRepellPower: parentConfig.mouseRepellPower,
				mouseRepelEasePower: parentConfig.mouseRepelEasePower
			};

			let texture: PIXI.Texture = settings.textures[child.texture] as PIXI.Texture;
			this._childParticles.push(this._createChildParticle(config, texture, settings.container));
		});
	}

	private _createChildParticle(
		config: TimelineItemConfig,
		texture: PIXI.Texture,
		container: PIXI.Container
	): TimelineItem {
		//A normal pixi sprite that will be animated along the timeline
		let item = new TimelineItem();

		item.relativeX = config.relativeX;
		item.relativeY = config.relativeY;
		item.easePower = config.easePower;
		item.parallaxOffsetPower = config.parallaxOffsetPower;
		item.parallaxPowerMouse = 0;

		if (config.alpha) {
			item.alpha = config.alpha;
		}

		if (config.tint) {
			item.tint = config.tint;
		}

		if (config.mouseRepellPower) {
			item.mouseRepellPower = config.mouseRepellPower;
		}

		if (config.mouseRepelEasePower) {
			item.mouseRepelEasePower = config.mouseRepelEasePower;
		}

		item.create(config, {
			container: container,
			texture: texture
		});

		return item;
	}
}
